import React, { useState } from 'react';
import Icon from '../../../components/AppIcon'; // Assuming Icon is available

const CollapsibleSection = ({ title, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="bg-card rounded-lg border border-border shadow-soft">
      <button
        className="flex justify-between items-center w-full p-4 text-left focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 className="text-lg font-medium text-foreground">{title}</h3>
        <Icon name={isOpen ? 'ChevronUp' : 'ChevronDown'} size={20} className="text-muted-foreground" />
      </button>
      {isOpen && (
        <div className="p-4 border-t border-border">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;